/**
 * Parse a URL query string into a plain object with string values.
 */
export function parseQueryString(search) {
  const trimmed = search.startsWith("?") ? search.slice(1) : search;
  const params = new URLSearchParams(trimmed);
  const result = {};

  for (const [key, value] of params) {
    result[key] = value;
  }

  return result;
}
